import { render, staticRenderFns } from "./VideoUploadDialog.vue?vue&type=template&id=6be46760&scoped=true"
import script from "./VideoUploadDialog.vue?vue&type=script&lang=js"
export * from "./VideoUploadDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoUploadDialog.vue?vue&type=style&index=0&id=6be46760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be46760",
  null
  
)

export default component.exports